module.exports = __webpack_public_path__ + "img/menu-item-eatsmart.3c01160e.svg";